import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParticlesListFilterComponent } from './particles-list-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { SharedModule } from '../../shared/shared.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { ParticlesListComponent } from './particles-list.component';

@NgModule({
  declarations: [ParticlesListComponent, ParticlesListFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule,
    RouterModule
  ],
  exports: [ParticlesListComponent, ParticlesListFilterComponent]
})
export class ParticlesListModule { }
